// Brand-driven MSISDN validation (rules = brandConfig.msisdn). Without a countryCode any
// 8-15 digit number passes, so the LP works before a market is configured.
export function isMsisdnValid(msisdn, rules = {}) {
  const digits = normalise(msisdn, rules)
  if (!digits) return false
  if (!rules.countryCode) return digits.length >= 8 && digits.length <= 15

  const local = digits.slice(rules.countryCode.length)
  if (rules.localLength && local.length !== rules.localLength) return false
  if (rules.localPrefixes?.length && !rules.localPrefixes.some((prefix) => local.startsWith(prefix))) return false
  return true
}

// Full international form (countryCode + local), trunk prefix dropped: 077… -> 25677….
export function formatMsisdn(msisdn, rules = {}) {
  return normalise(msisdn, rules)
}

function normalise(msisdn, { countryCode = '', trunkPrefix = '0' } = {}) {
  let digits = String(msisdn ?? '').replace(/\D/g, '')
  if (!digits || !countryCode || digits.startsWith(countryCode)) return digits
  if (trunkPrefix && digits.startsWith(trunkPrefix)) digits = digits.slice(trunkPrefix.length)
  return `${countryCode}${digits}`
}

export default { isMsisdnValid, formatMsisdn }
